import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class SharedService {

  constructor(
    private router: Router
  ) { }
  // Observable string sources
  private searchedTextSource = new Subject<string>();
  private activeFilterSource = new Subject<string>();
  private activeSortSource = new Subject<string>();
  currentactiveSort$ = new BehaviorSubject<string>("");
  private breadcrumMenuSource = new Subject<string[]>();
  private insideFolderfilesSource = new Subject<boolean>();
  private loadingSource = new Subject<boolean>();
  private updateBreadcrumIndexSource = new Subject<number>();
  private updateBreadcrumMenuSource = new Subject<object[]>();

  private clearBreadcrumSource = new Subject<boolean>();
  
  private loggedIn = new BehaviorSubject<boolean>(false);
  isShare$ = new BehaviorSubject<boolean>(false);
  isSiteRes$ = new BehaviorSubject<boolean>(false);
  private isSettings = new BehaviorSubject<boolean>(false);
  isUploadFlow$ = new BehaviorSubject<boolean>(false);
  isUploadScreen$ = new BehaviorSubject<boolean>(false);
  tabType$ =  new BehaviorSubject<number>(-1);
  
  uploadFile$ = new BehaviorSubject<any>(null);
  

  updateShareData$ = new BehaviorSubject<any>(null);
  updateDuplicateData$ = new BehaviorSubject<any>(null);

  siteResData$ = new BehaviorSubject<any>(null);

  // Observable string streams
  
  searchedText$ = this.searchedTextSource.asObservable();
  activeFilter$ = this.activeFilterSource.asObservable();
  loading$= this.loadingSource.asObservable();
  activeSort$ = this.activeSortSource.asObservable();
  breadcrumMenuSource$ = this.breadcrumMenuSource.asObservable();
  insideFolderfiles$= this.insideFolderfilesSource.asObservable();
  clearBreadcrumSource$= this.clearBreadcrumSource.asObservable();
  updateBreadcrumIndexSource$ = this.updateBreadcrumIndexSource.asObservable();
  updateBreadcrumMenuSource$= this.updateBreadcrumMenuSource.asObservable();
  // Service message commands
  setSeachText(searchedText: string) {
    this.searchedTextSource.next(searchedText);
  }

  
  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  login() {
    this.loggedIn.next(true);
  }

  logout() {
    this.loggedIn.next(false);
    this.router.navigate(['/login']);
  }

  get isSettingsScreen() {
    return this.isSettings.asObservable();
  }
  settingsScreen(isSetting:boolean) {
    this.isSettings.next(isSetting);
  }

  setFilter(activeFilter: string) {
    this.activeFilterSource.next(activeFilter);
  }

  setLoading(loading: boolean) {
    this.loadingSource.next(loading);
  }

  
  setSort(activeSort: string) {
    this.activeSortSource.next(activeSort);
    this.currentactiveSort$.next(activeSort)
  }

  addToBreadcrumMenu(obj:string[]) {
    this.breadcrumMenuSource.next(obj);
  }

  updateBreadcrumMenuIndex(index:number){
    this.updateBreadcrumIndexSource.next(index);
  }
  clearBreadcrumMenu(clear:boolean){
    this.clearBreadcrumSource.next(clear);
  }
  updateBreadcrumMenu(obj:object[]){
    this.updateBreadcrumMenuSource.next(obj)
  }
  setInsideFolderfiles(insideFolderfiles: boolean) {
    this.insideFolderfilesSource.next(insideFolderfiles);
  }

}
